{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6001",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "stacklight": {
    "colorValues": {
      "0": "off",
      "1": "red",
      "2": "green",
      "3": "blue",
      "4": "yellow",
      "5": "purple",
      "6": "cyan",
      "7": "white"
    },
    "lampsPlaceholderObject": "Components.<Component>.[PLACEHOLDER].<OrderedObject>.[PLACEHOLDER]",
    "signalVariable": {
      "id": "cf0c5a55-a8e8-4e94-85fe-043769fe0094",
      "modelUri": "http://opcfoundation.org/UA/IA/",
      "nodeId": "ns=1;i=6013",
      "displayName": "SignalOn",
      "variablePath": "SignalOn",
      "dataType": "Boolean",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "signalOnValue": "true",
    "signalOffValue": "false",
    "sortingVariable": {
      "id": "a816aca4-1b70-48f9-b95b-53bb304a80bc",
      "modelUri": "http://opcfoundation.org/UA/IA/",
      "nodeId": "ns=1;i=6015",
      "displayName": "NumberInList",
      "variablePath": "NumberInList",
      "dataType": "UInteger",
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "hasUnit": false,
      "hasRange": false
    },
    "colorVariable": {
      "id": "e022d6f0-95b5-4ca7-a2a3-f25e88a68767",
      "modelUri": "http://opcfoundation.org/UA/IA/",
      "nodeId": "ns=1;i=6016",
      "displayName": "SignalColor",
      "variablePath": "SignalColor",
      "dataType": "SignalColor",
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "timeline": {
    "variable": {
      "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
      "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
      "nodeId": "ns=1;i=6091",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "NotAvailable": "#ff8080",
      "OutOfService": "#ff0000",
      "Executing": "#f2ff00",
      "NotExecuting": "#0dff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "22ff23e4-31cd-417a-b477-6f000286248f",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6039",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductInstanceUri",
              "showAsLink": false,
              "valueVariable": {
                "id": "b9e3f5ec-b37d-40b9-b74e-83e4c906bf03",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6038",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serialnumber",
              "showAsLink": false,
              "valueVariable": {
                "id": "c587ae51-91ea-4365-bc9e-7c918060cbeb",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6040",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "ddc4aaca-9595-49c0-b3bc-e39c52f20131",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "1a57791f-08a1-48fd-b9d4-99bf3a5522ab",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "2890fa7a-5aa6-4579-b834-92597590b573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "MachineryItemState",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#804040",
                  "textColor": "#ffffff",
                  "value": "OutOfService",
                  "label": "Out Of Service"
                },
                {
                  "backgroundColor": "#ffff09",
                  "textColor": "#000000",
                  "value": "Executing"
                },
                {
                  "backgroundColor": "#0fff21",
                  "textColor": "#400040",
                  "value": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Components",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "5d3e9c45-4e22-4f17-8f9b-2f66086f2907",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6059",
                "displayName": "Manufacturer",
                "variablePath": "Components.<Component>.CurrentScale.<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "341cdc91-0bdc-49b7-a993-9f16e86312c5",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6061",
                "displayName": "Serial number",
                "variablePath": "Components.<Component>.CurrentScale.<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "title": "CurrentScale"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "eef19fde-4c21-47b7-86f4-b9bfd5010d37",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6066",
                "displayName": "Manufacturer",
                "variablePath": "Components.<Component>.LinearAxis.<Component>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "006f912a-72be-447b-ae9b-ae33fec6caab",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6072",
                "displayName": "Serial number",
                "variablePath": "Components.<Component>.LinearAxis.<Component>.Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "title": "LinearAxis"
        }
      ]
    }
  ]
}
